{
  "title": "Передача місцезнаходження дозволяє прискорити процес реєстрації",
  "body": "На жаль, без доступу до вашого місцезнаходження ми не можемо завершити реєстрацію. Будь ласка, надайте дозвіл на геолокацію для продовження. Ми використовуємо ваше місцезнаходження виключно для реєстрації на складі та не зберігаємо і не передаємо інформацію про ваше місцезнаходження третім особам.",
  "shareLocation": "Передати моє місцезнаходження"
}
